import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {type StemDate} from "../../../stem-core/time/Date";
import {BaseEnum, makeEnum} from "../../../stem-core/state/BaseEnum.js";
import {TaskStatus} from "../misc/GenericEnums";
import {FileResource} from "./FileResourceStore";

interface CreateReportRequest {
    merchantId: number;
    type: MerchantReportType;
    filters: any;
}

interface DeleteReportRequest {
    reportId: number;
}


@makeEnum
export class MerchantReportType extends BaseEnum {
    static PAYMENTS;
    static PURCHASES;
    static SUBSCRIPTIONS;
    static DONATIONS;
    static DONORS;
    static USERS;
    static AUDIENCE_MEMBERS;
}


@globalStore
export class MerchantReport extends BaseStore("MerchantReport") {
    @field(String) name: string;
    @field(MerchantReportType) type: MerchantReportType;
    @field(TaskStatus) status: TaskStatus;
    @field(Object) filters: any;
    @field(Date) createdAt: StemDate;
    @field(Number) fileSize: number;
    @field(FileResource) s3File: FileResource;

    isSucceeded(): boolean {
        return this.status === TaskStatus.SUCCEEDED;
    }

    isInProgress(): boolean {
        return this.status === TaskStatus.IN_PROGRESS;
    }
}

export async function apiMerchantCreateReport(merchantId: number, type: MerchantReportType, filters: any): Promise<any> {
    const request: CreateReportRequest = {
        merchantId,
        type,
        filters,
    }

    const response = await apiClient.post("/merchant/create_report", request);
    if (MerchantReport.loadObject(response)) {
        MerchantReport.dispatch("newOwnObject"); // Dispatch for the table to re-fetch
    }
    return response;
}

export async function apiMerchantDeleteReport(reportId: number): Promise<any> {
    return apiClient.post("/merchant/delete_report", {reportId} as DeleteReportRequest);
}
